<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">{{ $t('details.pre-orders') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <datatablebuttons/>
                <search @make_search="make_search" />
                <div class="table-responsive">
                    <table class="table table-striped dataTable my-4 w-100" id="details">
                      <thead>
                        <tr>
                          <th>
                            <div class="checkbox c-checkbox">
                              <label class="mb-0 p">
                                <input class="select-box" type="checkbox" v-model="selectAll">
                                <span class="fa fa-check"></span>
                              </label>
                            </div>
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'part__code',
                              'sorting_desc': ordering === '-part__code'
                            }"
                            @click="order('part__code')">{{ $t('details.code') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'part__name',
                              'sorting_desc': ordering === '-part__name'
                            }"
                            @click="order('part__name')">{{ $t('details.name') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'replenishment_qty',
                              'sorting_desc': ordering === '-replenishment_qty'
                            }"
                            @click="order('replenishment_qty')">{{ $t('details.replenishment-qty') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'part__unit__code',
                              'sorting_desc': ordering === '-part__unit__code'
                            }"
                            @click="order('part__unit__code')">{{ $t('details.unit-code') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'part__part_type__name',
                              'sorting_desc': ordering === '-part__part_type__name'
                            }"
                            @click="order('part__part_type__name')">{{ $t('part.type') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'warehouse__name',
                              'sorting_desc': ordering === '-warehouse__name'
                            }"
                            @click="order('warehouse__name')">{{ $t('details.warehouse') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'customer_number',
                              'sorting_desc': ordering === '-customer_number'
                            }"
                            @click="order('customer_number')">{{ $t('details.transport-nr') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'customer_name',
                              'sorting_desc': ordering === '-customer_name'
                            }"
                            @click="order('customer_name')">{{ $t('details.customer_name') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'creator__name',
                              'sorting_desc': ordering === '-creator__name'
                            }"
                            @click="order('creator__name')">{{ $t('details.creator') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'created',
                              'sorting_desc': ordering === '-created'}"
                            @click="order('created')">{{ $t('details.created') }} / <span class="text-muted font-italic">{{ $t('details.updated') }}</span>
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'tender__code',
                              'sorting_desc': ordering === '-tender__code'
                            }"
                            @click="order('tender__code')">{{ $t('details.tender') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'status',
                              'sorting_desc': ordering === '-status'
                            }"
                            @click="order('status')">{{ $t('details.status') }}
                          </th>
                          <th
                            :class="{
                              'sorting_asc': ordering === 'order_number',
                              'sorting_desc': ordering === '-order_number'
                            }"
                            @click="order('order_number')">{{ $t('details.order_number') }}
                          </th>
                          <th>BC</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr :key="row.id" class="gradeX" v-for="(row, index) in rows">
                          <td>
                            <div class="checkbox c-checkbox">
                              <label class="mb-0">
                                <input :value="row.id" class="select-box" type="checkbox" v-model="selected">
                                <span class="fa fa-check"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            {{ row.part_code }}
                          </td>
                          <td>
                            <button
                              class="btn btn-link pl-0 py-0 pr-1"
                              :title="$t('details.add-part-comment')"
                              @click="show_part_modal(row)">
                              <i :class="['fa-comment', row.part_comment ? 'fa text-primary' : 'far text-info']"></i>
                            </button>
                            {{ row.part_name }}
                          </td>
                          <td>{{ row.replenishment_qty > 0 ? row.replenishment_qty : 0 }}</td>
                          <td>{{ row.part_unit_code }}</td>
                          <td>{{ row.part_type_name }}</td>
                          <td>{{ row.warehouse_name_code }}</td>
                          <td>{{ row.customer_number }}</td>
                          <td>{{ row.customer_name }}</td>
                          <td>{{ row.creator_name }}</td>
                          <td>
                            {{ row.created | formatDateTime }}
                            <span
                              v-if="format_date_time(row.created) !== format_date_time(row.updated)"
                              class="text-muted font-italic small"><br>{{ row.updated | formatDateTime }}
                            </span>
                          </td>
                          <td>
                            <router-link
                              v-if="row.tender && row.tender_status==='DRAFT'"
                              :to="{name: 'tender_edit', params: {id: row.tender}}"
                              target="_blank">{{ row.tender_code }}
                            </router-link>
                            <router-link
                              v-else-if="row.tender"
                              :to="{name: 'tender_view', params: {id: row.tender}}"
                              target="_blank">{{ row.tender_code }}
                            </router-link>
                            <span v-else>{{ row.tender_code }}</span>
                          </td>
                          <td>
                            <div :class="statusClass(row.status)">
                              {{ $t(`details.state.${row.status}`.toLowerCase()) }}
                            </div>
                          </td>
                          <td>{{ row.order_number }}</td>
                          <td>
                            <b-c-detail-status
                              v-if="row.bc_id"
                              :detail="row"
                            />
                          </td>
                          <td>
                            <router-link
                              :to="{name: 'detail_edit', params: {id: row.id}}"
                              v-if="row.status === 'PREPARED'"
                              class="pl-1 far fa-edit"
                            />
                            <button
                              v-if="row.status==='PREPARED' && is_allowed"
                              class="btn btn-link pl-1 pt-1"
                              :title="$t('details.button-delete')"
                              @click="remove_detail(row.id, index)">
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </div>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * page_size + 1"
                  :to="(page - 1) * page_size + rows.length"
                  @paginate="paginate"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <part-comment-modal
      :show.sync="showPartModal"
      :row="activePartModalRow"
    />
  </section>
</template>

<script>
import api from '@/api'
import Datatablebuttons from '@/components/Datatablebuttons.vue'
import BCDetailStatus from "@/components/BCDetailStatus.vue";
import message from '@/message'
import moment from 'moment'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'
import PartCommentModal from "@/components/PartCommentModal.vue";

function calculateData(data) {
  let rowsData = []
  let rows = data

  let created = ''
  let updated = ''
  let createdUpdated = ''

  rows.forEach(row => {
    created = moment(String(row.created)).format('DD.MM.YYYY HH:mm')
    updated = moment(String(row.updated)).format('DD.MM.YYYY HH:mm')
    createdUpdated = created

    if (created !== updated) {
      createdUpdated += ' / ' + updated
    }

    rowsData.push({
      0: row.id,
      1: row.part_code,
      2: row.part_name,
      3: row.replacement_qty > 0 ? row.replacement_qty : 0,
      4: row.replenishment_qty > 0 ? row.replenishment_qty : 0,
      5: row.part_unit_code,
      6: row.warehouse_name,
      9: row.creator_name,
      10: createdUpdated,
      11: row.tender_code,
      12: row.status
    })
  })

  return rowsData
}

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || '-created'
  const page = parseInt(route.query.page) || 1
  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
      || {}
  let page_size = route.query.page_size
      || stored_page_size[route.name]
      || process.env.DEFAULT_PAGE_SIZE

  Promise.all([
    api.get(`/details/`, {
      params: {
        search: search,
        ordering: ordering,
        page: page,
        page_size: page_size
      }
    })
  ])
    .then(([details]) => {
      next({
        rows: details.data.results,
        rowsData: calculateData(details.data.results),
        search: search,
        ordering: ordering,
        pages: details.data.pages,
        count: details.data.count,
        page: page,
        page_size: page_size
      })
    })
}

export default {
  components: {
    PartCommentModal,
    BCDetailStatus,
    datatablebuttons: Datatablebuttons,
    pagination: Pagination,
    search: Search
  },
  data() {
    return {
      rows: [],
      rowsData: [],
      search: null,
      ordering: null,
      pages: null,
      page_size: null,
      count: null,
      page: null,
      showPartModal: false,
      activePartModalRow: {},
      selected: [],
      columns: [
        this.$i18n.t('details.code'),
        this.$i18n.t('details.name'),
        this.$i18n.t('details.replacement-qty'),
        this.$i18n.t('details.replenishment-qty'),
        this.$i18n.t('details.unit-code'),
        this.$i18n.t('details.warehouse'),
        this.$i18n.t('details.transport-nr'),
        this.$i18n.t('details.makes'),
        this.$i18n.t('details.creator'),
        this.$i18n.t('details.created') + ' / ' + this.$i18n.t('details.updated'),
        this.$i18n.t('details.tender'),
        this.$i18n.t('details.status')
      ]
    }
  },
  mounted () {
    this.$parent.menu = 'details'
    this.$parent.submenu = ''
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    show_part_modal(row) {
      this.showPartModal = true
      this.activePartModalRow = row
    },
    remove_detail (id, index) {
      this.$swal({
        type: 'warning',
        title: this.$i18n.t('details.are-you-sure'),
        text: this.$i18n.t('details.are-you-sure-text-cancel'),
        showCancelButton: true
      })
        .then((choice) => {
          if (choice.value) {
            api.delete(`/details/${id}/`)
              .then(() => {
                message.success(this.$i18n.t('details.deleted'))
                this.$delete(this.rows, index)
              })
              .catch(() => {
                message.error(this.$i18n.t('details.forbidden'))
              })
          }
        })
    },
    format_date_time (dt) {
      return moment(String(dt)).format('DD.MM.YYYY HH:mm')
    },
    order (o) {
      this.$parent.order(o, this.search, this.ordering)
    },
    paginate (p) {
      this.$parent.paginate(p, this.search, this.ordering)
    },
    make_search () {
      this.$parent.make_search(this.search, this.ordering)
    },
    statusClass (status) {
      let bgColor = 'bg-white'
      switch (status.toUpperCase()) {
        case 'PREPARED':
          bgColor = 'bg-gray'
          break
        case 'ORDERED':
          bgColor = 'bg-info-light'
          break
        case 'WAITING':
          bgColor = 'bg-warning-light'
          break
        case 'FAILED':
          bgColor = 'bg-danger-dark'
          break
        default:
          break
      }
      return 'rounded badge px-4 ml-2 text-sm d-lg-inline ' + bgColor
    },
  },
  computed: {
    is_allowed () {
      return this.$store.getters.user_group === 'Administrator' || this.$store.getters.user_group === 'Contractor'
    },
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    },
    selectAll: {
      get: function () {
        return this.rows ? this.selected.length === this.rows.length : false
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.rows.forEach(function (p) {
            selected.push(p.id)
          })
        }
        this.selected = selected
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Details.vue